import consola from 'consola';
import { getQueryOverrides } from '~~/unleash/client/utils/query-overrides';

export const storeModule = {
  namespaced: true,
  state: () => ({
    featureToggles: {},
  }),
  getters: {
    // get all feature toggles
    getFeatureToggles: (state) => state.featureToggles,
    // get a single feature toggle
    getFeatureToggle: (state) => (name) => state.featureToggles[name],
  },
  mutations: {
    setFeatureToggles(st, toggles) {
      st.featureToggles = toggles;
    },
  },
  actions: {
    // called from vue page component -> unleash plugin, populates toggle store
    // toggles come from the unleash api/instance via getVariant
    // toggle-overrides work via url param eg. &feature-my-feature=123
    trackFeatureToggles({ commit }, { toggles, query }) {
      if (query) {
        const overrides = getQueryOverrides(query);
        Object.entries(overrides).forEach(([name, variant]) => {
          consola.info(`Overriding feature: ${name} with variant: ${variant}`);
          toggles[name] = variant;
        });
      }

      commit('setFeatureToggles', toggles);
    },
  },
};

export default ({ store }) => {
  store.registerModule('unleash', storeModule);
};
